import { LocalStorageKeys } from "@shared/types/localTypes/storage.ts";
import window from "@shared/utils/app-window.ts";
import { DateTime } from "luxon";
import { useKeycloakStore } from "@shared/stores/keycloak.ts";

export const useSessionLogic = () => {
  const isSessionActive = () => {
    if (window.OPERATION_MODE === "partner_portal") {
      return true;
    }

    const lastLoginMillis =
      window.localStorage.getItem(LocalStorageKeys.LAST_SUCCESSFUL_LOGIN) ||
      "0";
    const lastLogoutMillis =
      window.localStorage.getItem(LocalStorageKeys.LAST_SUCCESSFUL_LOGOUT) ||
      "0";

    return parseInt(lastLoginMillis) > parseInt(lastLogoutMillis);
  };

  const lockReload = () => {
    window.sessionStorage.setItem(LocalStorageKeys.CAN_RELOAD_LOCK, "false");
  };
  const unlockReloadWithDelay = () => {
    setTimeout(() => {
      window.sessionStorage.setItem(LocalStorageKeys.CAN_RELOAD_LOCK, "true");
    }, 5000);
  };

  const canReload = () => {
    const canReloadStr =
      window.sessionStorage.getItem(LocalStorageKeys.CAN_RELOAD_LOCK) || "true";

    return canReloadStr === "true";
  };

  const getSessionType = () => {
    return isKeycloakSession() ? "IDP" : "API_PROXY";
  };

  const isKeycloakSession = () => {
    return useKeycloakStore().keycloak?.authenticated;
  };

  const setLastSessionAction = (
    action:
      | LocalStorageKeys.LAST_SUCCESSFUL_LOGOUT
      | LocalStorageKeys.LAST_SUCCESSFUL_LOGIN,
  ) => {
    const now = DateTime.now().toMillis().toString();
    window.localStorage.setItem(action, now);
  };

  const setLogoutClickTime = () => {
    const now = DateTime.now().toMillis().toString();
    window.sessionStorage.setItem(LocalStorageKeys.LOGOUT_CLICK_TIME, now);
  };

  const isLogoutRecentlyClicked = () => {
    const logoutClickTime = window.sessionStorage.getItem(
      LocalStorageKeys.LOGOUT_CLICK_TIME,
    );

    if (!logoutClickTime) {
      return false;
    }

    const logoutClickDateTime = DateTime.fromMillis(parseInt(logoutClickTime));
    return logoutClickDateTime.plus({ seconds: 5 }) > DateTime.now();
  };

  return {
    isSessionActive,
    lockReload,
    unlockReloadWithDelay,
    canReload,
    isKeycloakSession,
    setLastSessionAction,
    getSessionType,
    setLogoutClickTime,
    isLogoutRecentlyClicked,
  };
};
